/**
 * (后端接口没写好,防止硬编码后续改动麻烦)
 */

// 查询的字段名
export const QUERY_FIELD = {
  // 模版名称
  TEMPLATE_NAME: 'templateName',
  // 设备类型
  DEVICE_TYPE: 'typeIds',
};

// 表格字段名
export const TABLE_FIELD = {
  ID: 'id',
  // 模版名称
  TEMPLATE_NAME: 'name',
  // 设备类型id
  DEVICE_TYPE_ID: 'typeId',
  // 设备类型名称
  DEVICE_TYPE_NAME: 'typeName',
  // 最后操作时间
  UPDATE_TIME: 'updateTime',
  // 最后操作人
  UPDATE_USERNAME: 'updateUserName',
};

// 下一级页面的字段名(包括弹窗)
export const FIELDS = {
  // 模版名称
  TEMPLATE_NAME: 'templateName',
  // 设备类型
  DEVICE_TYPE: 'typeId',
  // 设备名称(后端直接返回了,不用去级联器中回显)
  DEVICE_NAME: 'typeName',
  // 字段配置数组
  FIELD_DATA_LIST: 'fieldDataList',

  /* 以下为字段配置弹窗中的字段 */
  // 字段名称
  FIELD_NAME: 'name',
  // 字段类型：1文本输入框、2下拉、3时间选择框、4数值输入框
  FIELD_TYPE: 'type',
  // 日期时间格式
  DATE_TIME_FORMAT: 'timeFormat',
  // 数值小数位数
  NUMBER_DECIMAL_PLACES: 'decimalDigits',
  // 枚举项列表
  ENUM_ITEM_LIST: 'enumNameList',
  // 在枚举项表格中,column的第一个dataIndex
  ENUM_ITEM_NAME: 'enumItemName',
  // 是否必填
  IS_REQUIRED: 'required',
  // 是否唯一性校验
  IS_UNIQUE: 'unique',
  // 选择类型:1单选，2多选;仅当字段类型为下拉框时传值
  SELECT_TYPE: 'selectType',
} as const;

// 弹窗选择字段类型values
export const FIELD_TYPE = {
  // 文本
  TEXT: 1,
  // 枚举
  ENUM: 2,
  // 日期时间
  DATETIME: 3,
  // 数值
  NUMBER: 4,
};

export const FIELD_TYPE_OPTIONS = [
  { label: '文本输入框', value: FIELD_TYPE.TEXT },
  { label: '下拉框', value: FIELD_TYPE.ENUM },
  { label: '时间选择框', value: FIELD_TYPE.DATETIME },
  { label: '数值输入框', value: FIELD_TYPE.NUMBER },
];

// 创建,编辑,查看
export const COMPONENT_MODE = {
  CREATE: 'create',
  EDIT: 'edit',
  VIEW: 'view',
} as const;

export const COMPONENT_MODE_LABELS: { [key: string]: string } = {
  [COMPONENT_MODE.CREATE]: '新建',
  [COMPONENT_MODE.EDIT]: '编辑',
  [COMPONENT_MODE.VIEW]: '查看',
};

// 'create' | 'edit' | 'view'
export type ComponentMode = (typeof COMPONENT_MODE)[keyof typeof COMPONENT_MODE];

export const SELECT_TYPE = {
  SINGLE: 1,
  MULTIPLE: 2,
};
